export { default as BuyEstimateV2 } from './BuyEstimateV2.gql';
export { default as DepositMethods } from './DepositMethods.gql';
export { default as GetTooltips } from './GetTooltips.gql';
export { default as LimitPresets } from './LimitPresets.gql';
export { default as MarketBuyPresets } from './MarketBuyPresets.gql';
export { default as MarketSellPresets } from './MarketSellPresets.gql';
export { default as Orderbook } from './Orderbook.gql';
export { default as SellEstimateV2 } from './SellEstimateV2.gql';
export { default as CurrentUserReferral } from './CurrentUserReferral.gql';
